import { omitKeys } from "@hex-insights/core";
import { Create, CreateRequiredKey, Detail, initialCreate } from "./form-values";

export type ParentFields = "announcementID" | "calendarEventID" | "newsletterID" | "postID" | "studentNoteID";

export type CreateInParent = Omit<Create, ParentFields>;

export type CreateInParentRequiredKey = Exclude<CreateRequiredKey, ParentFields>;

export type CreateInParentSubset<K extends keyof CreateInParent = keyof CreateInParent> = Pick<
	CreateInParent,
	CreateInParentRequiredKey | K
>;

export const blankItemInParent: CreateInParent = omitKeys(initialCreate, [
	"announcementID",
	"calendarEventID",
	"newsletterID",
	"postID",
	"studentNoteID",
]);

export type InstanceParentFields = "announcement" | "calendarEvent" | "newsletter" | "post" | "studentNote";

export type DetailInParent = Omit<Detail, ParentFields>;

export const detailInParentFieldInclusionMap: Record<keyof DetailInParent, true> = {
	isPublic: true,
	includeEmployees: true,
	includeGuardians: true,
	includeAllUsersOfPersonTypes: true,
	classYearCategoryIDs: true,
	classYearIDs: true,
	courseSectionIDs: true,
	homeRoomSectionIDs: true,
	userGroupIDs: true,
	userIDs: true,
};
